<template>
  <div>
    <div class="subtitle-2 mb-1">{{ titulo }}</div>

    <v-simple-table dense class="mb-2" v-if="rows.length > 0">
      <!--
      <thead>
        <tr>
          <th class="text-left" style="width:90%">{{ itemName }}</th>
          <th style="width:10%"></th>
          
        </tr>
      </thead>
      -->
      <tbody>
        <tr v-for="(row, i) in rows" :key="'row-'+i">
          <td style="width:90%">
            <v-text-field
              :value="row"
              dense
              outlined
              hide-details
              @input="updateRow(i, $event)"
              class="my-2"
            />
          </td>
          <td class="text-center" style="width:10%">
            <v-btn icon small @click="removeItem(i)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
        <tr v-if="rows.length === 0">
          <td class="text--disabled" colspan="2">
            Sin {{ itemName.toLowerCase() }}...
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-btn small outlined @click="addItem">
      <v-icon left small>mdi-plus</v-icon>
      Agregar {{ itemName }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ListaStringsEditor",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: Array, default: () => [] },
    titulo: { type: String, default: "Listado" },
    itemName: { type: String, default: "Elemento" },
  },
  data() {
    return {
      rows: [],
    };
  },
  created() {
    this.syncFromProp();
  },
  watch: {
    // Solo sincroniza si el contenido realmente cambió
    value: {
      handler(newVal) {
        const a = this.normalize(this.rows);
        const b = this.normalize(newVal);
        if (!this.arrEqual(a, b)) {
          this.rows = b.slice();
        }
      },
      deep: true,
    },
  },
  methods: {
    normalize(arr) {
      const incoming = Array.isArray(arr) ? arr : [];
      return incoming
        .map(v => (v == null ? "" : String(v)))
        .map(v => v.trim())
        .filter(v => v !== "");
    },
    filteredRows() {
      return this.normalize(this.rows);
    },
    emitFiltered() {
      this.$emit("input", this.filteredRows());
    },
    syncFromProp() {
      this.rows = this.normalize(this.value);
    },
    addItem() {
      this.rows.push("");
      this.emitFiltered();
    },
    removeItem(index) {
      this.rows.splice(index, 1);
      this.emitFiltered();
    },
    updateRow(index, val) {
      this.$set(this.rows, index, val);
      this.emitFiltered();
    },
    arrEqual(a, b) {
      if (!Array.isArray(a) || !Array.isArray(b)) return false;
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    },
  },
};
</script>
